class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.menuList = document.querySelectorAll('.mega-menu__list')
    this.menuList.forEach((item) => {
      const itemList = item.querySelectorAll('& > li')
      item.querySelectorAll('& > li').forEach((menuItem) => {
        menuItem.addEventListener('mouseover', this.add.bind(this, itemList, menuItem))
        menuItem.addEventListener('mouseout', this.remove.bind(this, itemList))
      });
    })

    this.menuItemList = document.querySelectorAll('.mega-menu__list > li');
  }

  add(itemList, item) {
    itemList.forEach((item) => item.classList.remove('mega-menu_item-active'))
    item.classList.add('mega-menu_item-active')
  }

  remove(itemList) {
    itemList.forEach((item) => item.classList.remove('mega-menu_item-active'))
    // itemList[0].classList.add('mega-menu_item-active')
  }
}

customElements.define('mega-menu-content', MegaMenu);